<template>
  <DataTable :data-model="'samples'"
             :display-name-plural="$t('entities.Sample.Plural')"
             :display-name-singular="$t('entities.Sample.Singular')"
             :permission-name="'Samples'"
             :allow-delete="false"
             :allow-create="false"
             :exclude-fields="['id', 'customerId', 'hasBarcode']">
    <template #cell(status)="row">
      {{ $t('samples.Status.'+row.item.status) }}
    </template>
  </DataTable>
</template>
<script>
import DataTable from '@components/admin/DataTable';

export default {
  components: {
    DataTable
  }
};
</script>
<style scoped></style>
